export default __webpack_public_path__ + "static/media/storageUnit1-afterB-1440w.619c38d2.webp";